import styled from 'styled-components';
import { motion } from 'framer-motion';
import { subTitleText, textLarge, textMedium, textSmall, titleText } from '../../styles/texts';

export const Wrapper = styled(motion.div)`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (${({ theme }) => theme.base.breakpoint.XL}) {
    padding: 0 16px;
  }
`;

export const Container = styled.div`
  max-width: 1340px;
  width: 100%;
`;

export const Info = styled.p`
  margin: 4px 0 14px;
  ${titleText};
  font-weight: bold;

  @media (${({ theme }) => theme.base.breakpoint.XL}) {
    margin-top: 46px;
  }
`;

export const InfoSubtitle = styled.p`
  ${subTitleText};
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 32px;
`;

export const WidgetContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 38px;

  @media (${({ theme }) => theme.base.breakpoint.L}) {
    flex-direction: column;
  }
`;

export const Widget = styled.div`
  flex: 1;
  padding: 24px;
  background: ${({ theme }) => theme.color.background.secondary};
  border-radius: 15px;
  text-align: center;
`;

export const WidgetTitle = styled.p`
  ${textMedium};
  color: ${({ theme }) => theme.color.text.primary.darkGray};
  margin-bottom: 12px;
`;

export const WidgetValue = styled.p`
  ${titleText};
  font-size: 32px;
  font-weight: bold;
  color: ${({ theme }) => theme.color.text.primary.dark};
`;

export const ChartWrapper = styled.div`
  margin-bottom: 38px;
  padding: 50px 50px 18px 20px;
  max-width: 888px;
  width: 100%;
  border-radius: 30px;
  background: ${({ theme }) => theme.color.background.secondary};
`;

export const ChartTitle = styled.p`
  ${textLarge};
  margin-bottom: 20px;
  font-weight: 500;
`;

export const TableWrapper = styled.div`
  position: relative;
  padding: 20px 24px;
  max-width: 888px;
  width: 100%;
  border-radius: 30px;
  background: ${({ theme }) => theme.color.background.secondary};
`;


export const TableWrapperTitle = styled.p`
  ${textLarge};
  margin-bottom: 10px;
`;

export const TableSubtitle = styled.p`
  ${textMedium};
  color: ${({ theme }) => theme.color.text.primary.darkGray};
  margin-bottom: 20px;
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${({ color }) => color}20;
  color: ${({ color }) => color};
  text-align: center;
`;

export const DownloadButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  background: ${({ theme }) => theme.color.background.primary};
  border: 1px solid ${({ theme }) => theme.color.border.gray};
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;

  svg {
    width: 16px;
    height: 16px;
    fill: ${({ theme }) => theme.color.text.primary.main};
  }

  &:hover {
    background: ${({ theme }) => theme.color.background.lightWhite};
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
  }
`;



// Zusätzliche Styles für erweiterte Features

export const FilterContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  padding: 16px;
  background: ${({ theme }) => theme.color.background.lightWhite};
  border-radius: 12px;

  @media (${({ theme }) => theme.base.breakpoint.L}) {
    flex-direction: column;
  }
`;

export const FilterItem = styled.div`
  flex: 1;
`;

export const SummaryContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;

  @media (${({ theme }) => theme.base.breakpoint.L}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (${({ theme }) => theme.base.breakpoint.M}) {
    grid-template-columns: 1fr;
  }
`;

export const SummaryItem = styled.div`
  padding: 16px;
  background: ${({ theme }) => theme.color.background.secondary};
  border-radius: 12px;
  text-align: center;
`;

export const SummaryLabel = styled.p`
  ${textSmall};
  color: ${({ theme }) => theme.color.text.primary.darkGray};
  margin-bottom: 8px;
`;

export const SummaryValue = styled.p`
  ${titleText};
  font-size: 24px;
  color: ${({ color, theme }) => color || theme.color.text.primary.dark};
`;


export const ModalContent = styled.div`
  background: ${({ theme }) => theme.color.background.secondary};
  border-radius: 18px;
  padding: 28px 32px;
  max-width: 600px;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.color.background.outline};
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.color.background.outline};
  gap: 24px;

  div h2 {
    ${textLarge};
    font-weight: bold;
    margin-bottom: 4px;
  }
  
  div p {
    ${textSmall};
    color: ${({ theme }) => theme.color.text.primary.darkGray};
  }
`;

export const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 28px 28px;

  @media (${({ theme }) => theme.base.breakpoint.M}) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

export const ModalMetaRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  margin-top: 12px;
`;

export const StatusChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid ${({ color }) => color};
  background: ${({ color }) => `${color}14`};
  color: ${({ color }) => color};
  font-size: 12px;
  font-weight: 600;
`;

export const SectionTitle = styled.p`
  ${textMedium};
  font-weight: 600;
  color: ${({ theme }) => theme.color.text.primary.dark};
  margin: 12px 0 18px;
`;

export const SectionBlock = styled.div`
  margin-bottom: 20px;
`;

export const DetailItem = styled.div`
  // Bei Bedarf für ein einzelnes Element über die volle Breite
  ${({ fullWidth }) => fullWidth && `
    grid-column: 1 / -1;
  `}
`;

export const DetailRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;

  svg {
    width: 18px;
    height: 18px;
    color: ${({ theme }) => theme.color.text.primary.darkGray};
    flex: 0 0 auto;
    margin-top: 2px;
  }
`;

export const DetailContent = styled.div`
  min-width: 0;
`;

export const DetailLabel = styled.p`
  ${textSmall};
  color: ${({ theme }) => theme.color.text.primary.darkGray};
  margin-bottom: 8px;
`;

export const DetailValue = styled.p`
  ${textMedium};
  color: ${({ theme }) => theme.color.text.primary.dark};
  font-weight: 500;
`;

// Neu: Spezieller Stil für den hervorgehobenen Erstattungsbetrag
export const ReimbursementAmount = styled.p`
  ${titleText};
  font-size: 28px;
  font-weight: bold;
  color: ${({ theme }) => theme.color.main.primary};
  margin-top: 2px;
`;

// Neu: Eine visuelle Trennlinie
export const Divider = styled.hr`
  grid-column: 1 / -1;
  border: none;
  height: 1px;
  background-color: ${({ theme }) => theme.color.background.outline};
  margin: 16px 0;
`;


export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid ${({ theme }) => theme.color.background.outline};

  // Stellt sicher, dass der Button Icon und Text korrekt anzeigt
  button {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 20px;
    font-size: 15px;
    color: ${({ theme }) => theme.color.text.primary.dark}; 
    
    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

export const CloseButton = styled.button`
  border: none;
  background: transparent;
  padding: 6px;
  margin-top: -2px;
  cursor: pointer;
  color: ${({ theme }) => theme.color.text.primary.darkGray};

  &:hover {
    color: ${({ theme }) => theme.color.text.primary.dark};
  }
`;

// -- ENDE: Verbesserte Modal-Styles --

// Hover-Effekt für Tabellenzeilen
export const TableRowHover = styled.tr`
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.color.background.lightWhite};
  }
`;

// Animierte Status-Indikatoren
export const AnimatedStatusIndicator = styled.div`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 8px;
  background-color: ${({ color }) => color};
  
  ${({ animate }) => animate && `
    animation: pulse 2s infinite;
    
    @keyframes pulse {
      0% {
        opacity: 1;
        transform: scale(1);
      }
      50% {
        opacity: 0.6;
        transform: scale(1.1);
      }
      100% {
        opacity: 1;
        transform: scale(1);
      }
    }
  `}
`;

// Stromrechnung hochladen – Sektion
export const ElectricityUploadSection = styled.div`
  margin-bottom: 38px;
  padding: 24px 28px;
  max-width: 888px;
  width: 100%;
  border-radius: 30px;
  background: ${({ theme }) => theme.color.background.secondary};
  border: 2px solid transparent;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  ${({ $highlight, theme }) =>
    $highlight &&
    `
    border-color: #FF8E4F;
    box-shadow: 0 0 0 1px #FF8E4F20;
  `}
`;

export const ElectricityUploadTitle = styled.p`
  ${textLarge};
  font-weight: 600;
  margin-bottom: 12px;
  color: ${({ theme }) => theme.color.text.primary.dark};
`;

export const ElectricityUploadInfo = styled.p`
  ${textMedium};
  color: ${({ theme }) => theme.color.text.primary.darkGray};
  line-height: 1.5;
  margin-bottom: 16px;
`;

export const ElectricityUploadRequiredHint = styled.p`
  ${textSmall};
  color: #FF8E4F;
  font-weight: 500;
  margin-bottom: 16px;
`;

export const ElectricityUploadHistoryTitle = styled.p`
  ${textMedium};
  font-weight: 600;
  margin: 0 0 12px;
  color: ${({ theme }) => theme.color.text.primary.dark};
`;

export const ElectricityUploadHistoryList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const ElectricityUploadHistoryItem = styled.li`
  ${textSmall};
  padding: 10px 14px;
  background: ${({ theme }) => theme.color.background.primary};
  border-radius: 10px;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.color.text.primary.darkGray};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const ElectricityHistoryWidget = styled.div`
  margin-bottom: 38px;
  padding: 24px 28px;
  max-width: 888px;
  width: 100%;
  border-radius: 30px;
  background: ${({ theme }) => theme.color.background.secondary};
`;

export const ElectricityFormRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
`;

export const ElectricityFormField = styled.div`
  flex: 1;
  min-width: 200px;
`;

export const ElectricityFormLabel = styled.label`
  ${textSmall};
  display: block;
  margin-bottom: 6px;
  color: ${({ theme }) => theme.color.text.primary.darkGray};
`;

export const ElectricitySelect = styled.select`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid ${({ theme }) => theme.color.border.gray};
  border-radius: 8px;
  ${textMedium};
  color: ${({ theme }) => theme.color.text.primary.dark};
  background: ${({ theme }) => theme.color.background.primary};
`;

export const ElectricityUploadDropzone = styled.div`
  border: 2px dashed ${({ theme }) => theme.color.border.gray};
  border-radius: 12px;
  padding: 32px 24px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
  color: ${({ theme }) => theme.color.text.primary.darkGray};
  ${textMedium};
  &:hover {
    border-color: ${({ theme }) => theme.color.text.primary.darkGray};
    background: ${({ theme }) => theme.color.background.lightWhite};
  }
  &.drag-over {
    border-color: ${({ theme }) => theme.color.primary?.main || '#53AF31'};
    background: ${({ theme }) => theme.color.background.lightWhite};
  }
`;